import React, { useEffect, useState, Fragment } from 'react';
import { Card, Row, Col, Form, Container } from 'react-bootstrap';
import { serviceGetConfirmaCierreRechazo, serviceGetDetalles } from '../../../../api/api-confirmar-cierre';
import Destinatario from './destinatario';

const VisarCierre = ({ action, cfg_form, values, errors, touched, handleBlur, handleChange, setFieldValue, solicitud, setShowConfirm }) => {
    const [confRechCierre, setConfRechCierre] = useState([]);
    const [motivosRechazo, setMotivosRechazo] = useState([]);

    useEffect(() => {
        getConfirmaCierreRechazo();
        getMotivoRechazo();
    }, [])

    useEffect(() => {
        if (solicitud) {
            setFieldValue('confirmaCierre', solicitud?.idEstadoSolicitud && solicitud?.idEstadoSolicitud !== 248000 ? solicitud?.idEstadoSolicitud : "");
            setFieldValue('motivoRechazo', action === "rechcierre" && solicitud?.idMotivoRechazo ? solicitud?.idMotivoRechazo : "");
            setFieldValue('honorario', solicitud?.honorarioPendiente === 0 ? false : true);
            setFieldValue('comentarioRespuesta', solicitud?.comentarioRespuesta ?? "");
        }
    }, [solicitud])

    const getConfirmaCierreRechazo = async () => {
        let query = Buffer.from(JSON.stringify({ tipoGestion: 235003, concepto: 269 })).toString('base64');
        const response = await serviceGetConfirmaCierreRechazo(query);

        if (action === "confcierre") setConfRechCierre(response.filter(value => value.situacionEstado === 215006));
        else setConfRechCierre(response.filter(value => value.situacionEstado === 215007));
    }

    const getMotivoRechazo = async () => {
        let query = Buffer.from(JSON.stringify({ concepto: 271 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setMotivosRechazo(response);
    }

    const handleConfirmCierre = async (value) => {
        let count = 0;
        confRechCierre.forEach(v => { if (v.id === Number(value) && v.accion === 1) count++ });

        setShowConfirm(count > 0);
    }

    return (
        <Fragment>
            <Container>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {action === "confcierre" ? (cfg_form && cfg_form["modalconfirmarcierre-title"]) : (cfg_form && cfg_form["modalconfirmarcierre-subtitlerechazo"])}
                    </Card.Header>

                    <Card.Body style={{ padding: '5px 20px' }}>
                        <Row>
                            <Col md='4' style={{ marginRight: action === "confcierre" ? '50px' : '0' }}>
                                <Form.Label className='mb-0 mt-2 is_required'>
                                    {action === "confcierre" ? (cfg_form && cfg_form["modalconfirmarcierre-cmb-confirmacierre"]) : "Confirma Rechazo"}
                                </Form.Label>
                                <Form.Select
                                    className='mt-2'
                                    name='confirmaCierre'
                                    value={values.confirmaCierre}
                                    onChange={(e) => { handleChange(e); handleConfirmCierre(e.target.value); }}
                                    onBlur={handleBlur}>

                                    <option value={''}>Seleccione...</option>
                                    {confRechCierre?.map((c) => (
                                        <option key={c.id} value={c.id}>{c.nombre}</option>
                                    ))}
                                </Form.Select>
                                {errors.confirmaCierre && touched.confirmaCierre &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.confirmaCierre}
                                    </Form.Text>
                                }
                            </Col>
                            {action === "rechcierre" &&
                                <Col md='4'>
                                    <Form.Label className='mb-0 mt-2 is_required'>
                                        {cfg_form && cfg_form["modalconfirmarcierre-cmb-motivorech"]}
                                    </Form.Label>
                                    <Form.Select
                                        className='mt-2'
                                        name='motivoRechazo'
                                        value={values.motivoRechazo}
                                        onChange={(e) => handleChange(e)}
                                        onBlur={handleBlur}>

                                        <option value={''}>Seleccione...</option>
                                        {motivosRechazo?.map((c) => (
                                            <option key={c.id} value={c.id}>{c.nombre}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.motivoRechazo && touched.motivoRechazo &&
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {errors.motivoRechazo}
                                        </Form.Text>
                                    }
                                </Col>
                            }
                            <Col md='4'>
                                <Form.Label className='mb-0 mt-2'></Form.Label>
                                <Form.Check
                                    className='mt-3'
                                    name='honorario'
                                    label="Honorario Pendiente"
                                    checked={values.honorario}
                                    onChange={(e) => handleChange(e)}
                                />
                            </Col>

                            <Col md='12' className='mt-2'>
                                <Form.Label className='mb-0 mt-2 is_required'>
                                    {action === "confcierre" ? (cfg_form && cfg_form["modalconfirmarcierre-input-comentarioanalista"]) : (cfg_form && cfg_form["modalconfirmarcierre-input-comentariorechazo"])}
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    className='mt-2 mb-3'
                                    name='comentarioRespuesta'
                                    value={values.comentarioRespuesta}
                                    onChange={(e) => handleChange(e)}
                                    onBlur={handleBlur}
                                />
                                {errors.comentarioRespuesta && touched.comentarioRespuesta &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {errors.comentarioRespuesta}
                                    </Form.Text>
                                }
                            </Col>
                        </Row>

                        {action === "rechcierre" && <Destinatario cfg_form={cfg_form} idSolicitud={solicitud?.idSolicitud} idMotivo={solicitud?.idMotivoSolDcto} />}
                    </Card.Body>
                </Card>
            </Container>
            <style type='text/css'>
                {`
                    label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default VisarCierre;